import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { getHomePath } from '@/constants/routes';
import { useAuthStore } from '@/stores/auth.store';
import type { UserRole } from '@/types/auth';

interface RoleGuardProps {
  allowedRoles: UserRole[];
  children: ReactNode;
}

export function RoleGuard({ allowedRoles, children }: RoleGuardProps) {
  const user = useAuthStore((state) => state.user);

  if (!user) {
    return null;
  }

  if (!allowedRoles.includes(user.role)) {
    return <Navigate to={getHomePath(user)} replace />;
  }

  return <>{children}</>;
}
